<div class="go-back">
	<a href="javascript:void(0);" (click)="onCancel()">
		<i class="fa fa-arrow-left"></i>
		<h6 class="text-uppercase">Rule notifications</h6>
	</a>
	<a href="javascript:void(0);" class="mark-all-read" (click)="markAsRead()">
		<h6 class="text-uppercase">Mark all as read</h6>
	</a>
</div>
<div class="content-notifications">
	<div class="wrapper rule-log-info" *ngFor="let log of ruleLog">
		<div class="rule-title rule-log-info__title">
			{{ log.title }}
		</div>
		<div class="rule-log-info__modified">Section: {{ log.section | ruleSectionLabel | titlecase }}</div>
		<div class="rule-log-info__modified">Modified by {{ log.modifiedBy }}</div>
		<div class="rule-log-info__date">Hour {{ log.date | date: 'shortTime' }}</div>
	</div>
</div>
